<script lang="ts" setup>
import IoInputWrapper from '@/components/form/InputWrapper.vue';

const modelValue = defineModel<string | number>();

withDefaults(defineProps<{
  label?: string
  type?: string
  placeholder?: string
}>(), {
  label: undefined,
  type: 'text',
  placeholder: undefined,
});
</script>

<template>
  <IoInputWrapper
    v-slot:default="{ inputId }"
    :label="label"
  >
    <input
      :id="inputId"
      :type="type"
      :placeholder="placeholder"
      style="width: 100%;"
      v-model="modelValue"
    >
  </IoInputWrapper>
</template>
